import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Play, Pause, RotateCcw } from "lucide-react";
import { api } from "../lib/api";

function OverlayTimer({ name, accent }) {
  const [secs, setSecs] = useState(60);
  const [running, setRunning] = useState(false);
  useEffect(() => {
    if (!running) return;
    const id = setInterval(() => {
      setSecs((s) => {
        if (s <= 1) { setRunning(false); return 0; }
        return s - 1;
      });
    }, 1000);
    return () => clearInterval(id);
  }, [running]);
  const done = secs <= 0;
  const mm = Math.floor(secs / 60);
  const ss = String(secs % 60).padStart(2, "0");
  return (
    <div data-testid="overlay-timer" className="rounded-2xl bg-black/55 backdrop-blur-md border border-white/10 px-8 py-6 min-w-[240px]">
      <p className="text-sm font-bold uppercase tracking-widest text-white/70 mb-1 truncate max-w-[260px]">{name}</p>
      <p className={`text-7xl font-black tabular-nums leading-none ${done ? "text-red-500" : accent}`}>{mm}:{ss}</p>
      <div className="flex gap-2 mt-4">
        <button data-testid="overlay-toggle-btn" disabled={done} onClick={() => setRunning((r) => !r)}
          className="rounded-full bg-emerald-500 hover:bg-emerald-400 disabled:opacity-40 text-zinc-950 font-bold text-sm px-4 h-9 inline-flex items-center gap-1.5">
          {running ? <Pause size={14} /> : <Play size={14} />}{running ? "Pause" : "Start"}
        </button>
        <button data-testid="overlay-reset-btn" onClick={() => { setSecs(60); setRunning(false); }}
          className="rounded-full bg-white/10 hover:bg-white/20 text-white font-bold text-sm px-4 h-9 inline-flex items-center gap-1.5">
          <RotateCcw size={14} /> Reset
        </button>
      </div>
    </div>
  );
}

export default function TimerOverlay() {
  const { id } = useParams();
  const [debate, setDebate] = useState(null);

  useEffect(() => {
    const el = document.querySelector(".App");
    const prev = { body: document.body.style.background, html: document.documentElement.style.background, app: el?.style.background };
    document.body.style.background = "transparent";
    document.documentElement.style.background = "transparent";
    if (el) el.style.background = "transparent";
    return () => {
      document.body.style.background = prev.body;
      document.documentElement.style.background = prev.html;
      if (el) el.style.background = prev.app;
    };
  }, []);

  useEffect(() => {
    api.get("/debates").then(({ data }) => {
      const d = (data || []).find((x) => x.id === id);
      if (d) setDebate(d);
    }).catch((e) => console.error("Overlay: failed to load debate", e));
  }, [id]);

  const aName = debate?.streamer_a_name || "Streamer A";
  const bName = debate?.streamer_b_name || "Streamer B";

  return (
    <div data-testid="timer-overlay-page" className="min-h-screen w-full flex items-end justify-center p-6 bg-transparent">
      <div className="flex flex-wrap gap-5 justify-center">
        <OverlayTimer name={aName} accent="text-emerald-400" />
        <OverlayTimer name={bName} accent="text-cyan-400" />
      </div>
    </div>
  );
}
